const About = () => {
  return (
    <article className="container p-3">
      <h1 className="text-center">ABOUT US</h1>
      <div className="row text-center d-flex justify-content-center">
        <div className="col-sm-12 col-md-6 col-lg-4">
          <i className="fas fa-globe-americas fa-2x"></i>
          <h4>Online Courses</h4>
          <p>
            Lorem, ipsum dolor sit amet consectetur adipisicing elit.
            Praesentium veniam tempore odio, distinctio neque enim eveniet
            consequatur magnam vero ut.
          </p>
        </div>
        <div className="col-sm-12 col-md-6 col-lg-5">
          <i className="fas fas fa-headset fa-2x"></i>
          <h4>Full-time Mentoring</h4>
          <p>
            Lorem, ipsum dolor sit amet consectetur adipisicing elit.
            Praesentium veniam tempore odio, distinctio neque enim eveniet
            consequatur magnam vero ut. Lorem ipsum dolor, sit amet consectetur
            adipisicing elit. Assumenda sit inventore quae cupiditate, unde
            voluptate.
          </p>
        </div>
        <div className="col-sm-12 col-md-6 col-lg-3">
          <i className="fas fa-book-open fa-2x"></i>
          <h4>Learn Yourself</h4>
          <p>
            Lorem, ipsum dolor sit amet consectetur adipisicing elit.
            Praesentium veniam tempore odio, distinctio neque enim eveniet
            consequatur magnam vero ut.
          </p>
        </div>
      </div>
    </article>
  );
};

export default About;
